import React from 'react'

import {
  Icon,
  SH1,
  Select,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import { BottomSheet } from '@zet/design-system/bottomSheet'
import Pressable from '@zet/design-system/pressable'
import { useUnsafeVariable } from 'nativewind'

interface DropDownProps {
  label?: string
  dropdownMode?: 'single' | 'multiple'
  onDismiss: () => void
  selectedValue: string | null
  onSelect: (value: string, displayText: string) => void
  setDropDownVisible: (visible: boolean) => void
  dropDownVisible: boolean
  dropOptions: { optionValue: string; optionId: string }[]
}

export const DropDown: React.FC<DropDownProps> = ({
  label = 'Select Dropdown',
  dropdownMode = 'single',
  onDismiss,
  selectedValue,
  onSelect,
  setDropDownVisible,
  dropDownVisible,
  dropOptions,
}) => {
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  function selectValue(value: string, displayText: string) {
    setDropDownVisible(false)
    onSelect(value, displayText)
  }

  const Header = () => (
    <XStack className="items-center">
      <Stack>
        <Icon type="WorkOutlined" size={24} />
      </Stack>
      <SH1 className="ml-2" numberOfLines={1} ellipsizeMode="tail">
        {label}
      </SH1>
      <Pressable onPress={() => setDropDownVisible(false)} className="ml-auto">
        <Icon size={24} type="Close" />
      </Pressable>
    </XStack>
  )

  return (
    <Stack>
      <BottomSheet
        visible={dropDownVisible}
        onDismiss={onDismiss}
        header={<Header />}
      >
        <>
          <Stack></Stack>
          <Stack className="px-3 pb-3">
            <Stack className="">
              <Select
                value={selectedValue}
                mode={dropdownMode}
                onChange={selectValue}
              >
                {dropOptions?.map(({ optionValue, optionId }) => (
                  <Select.Option
                    key={optionId}
                    name={optionId}
                    displayText={optionValue}
                    selectedValue={selectedValue}
                    optionContainerStyle="h-6 mt-3 w-full justify-center rounded-lg"
                    showToggle={dropdownMode === 'single' ? false : true}
                    iconColor={{
                      active: colorPrimary100,
                      inActive: zetColors.grays[60],
                    }}
                  >
                    <SH1>{optionValue}</SH1>
                  </Select.Option>
                ))}
              </Select>
            </Stack>
          </Stack>
        </>
      </BottomSheet>
    </Stack>
  )
}
